import api from "../apiInstance"
import { NotificationsListResponse } from "./interfaces/Notifications"
import { PaginatedListResponse } from "./interfaces/paging"

export const getUserNotifications = async (take: number, skip: number): Promise<PaginatedListResponse<NotificationsListResponse>>  => {
    const res = await api.get<PaginatedListResponse<NotificationsListResponse>>(process.env.REACT_APP_RENTIC_API_URL! + '/notifications/user_notifications?take=' + take.toString() + '&skip=' + skip.toString());

    return res.data;
}

export const markNotificationsAsRead = async (chatChannelId: number): Promise<boolean> => {
    const res = await api.post<boolean>(process.env.REACT_APP_RENTIC_API_URL! +
        '/notifications/mark_chat_notifications_read/' + chatChannelId.toString());

    return res.data;
}

export const getUnreadNotificationsCount = async (): Promise<number> => {
    if (api.defaults.headers.common['Authorization']) {
        if (!(api.defaults.headers.common['Authorization'] as string).includes("Bearer")) {
            return 0;
        }
        const res = await api.get<number>(process.env.REACT_APP_RENTIC_API_URL! +
            '/notifications/count_unseen_notifications');

        return res.data;
    }

    return 0;
}

export const markAllUserNotificationsAsRead = async (): Promise<boolean> => {
    const res = await api.post<boolean>(process.env.REACT_APP_RENTIC_API_URL! +
        '/notifications/mark_all_notifications_read');

    return res.data;
}
